import React from 'react'

export const ORIGINAL_PATH = '/'

export const OriginalPathContext = React.createContext(ORIGINAL_PATH)
